__turbopack_context__.v({
  "categories": "CategorySelector-module__qGua5G__categories",
  "main": "CategorySelector-module__qGua5G__main",
  "results": "CategorySelector-module__qGua5G__results",
});
